function getAgent(state, id) {
  return state.agents.find((a) => a.id === id);
}

export default {
  agents(state, agents) {
    state.agents = agents;
  },
  loading(state, isLoading) {
    state.isLoading = isLoading;
  },
  error(state, hasError) {
    state.hasError = hasError;
  },
  addNewAgent(state, id) {
    state.agents = [
      ...state.agents,
      {
        id,
        firstName: state.newAgentForm.firstName,
        lastName: state.newAgentForm.lastName,
        email: state.newAgentForm.email,
        status: 0,
        avatar: null,
        permissions: [],
        isLoading: false,
        isOpened: true,
      },
    ];
  },
  removeAgent(state, id) {
    state.agents = state.agents.filter((a) => a.id !== id);
  },
  updateAgentDetails(state, { id, firstName, lastName }) {
    const index = state.agents.findIndex((a) => a.id === id);
    state.agents[index].firstName = firstName;
    state.agents[index].lastName = lastName;
  },
  resetNewAgentForm(state) {
    state.newAgentForm = {
      firstName: "",
      lastName: "",
      email: "",
    };
  },
  updateAgentPermissionsLoader(state, { id, isLoading }) {
    const agent = getAgent(state, id);
    agent.isLoading = isLoading;
  },
  setAgentPermissions(state, { id, permissions }) {
    const agent = getAgent(state, id);
    agent.permissions = permissions;
  },
  updatePermissionsPresets(state, presets) {
    state.permissionsPresets = presets;
  },
};
